export const projectSections = [
  {
    title: 'DATA',
    items: [
      { key: 'upload', label: 'Upload Data' },
      { key: 'annotate', label: 'Annotate' },
      { key: 'dataset', label: 'Dataset', badge: '1' },
      { key: 'versions', label: 'Versions' },
      { key: 'analytics', label: 'Analytics' },
      { key: 'classes', label: 'Classes & Tags' },
    ],
  },
  {
    title: 'MODELS',
    items: [
      { key: 'train', label: 'Train' },
      { key: 'models', label: 'Models' },
      { key: 'nas', label: 'NAS' },
      { key: 'visualize', label: 'Visualize' },
    ],
  },
  {
    title: 'DEPLOY',
    items: [{ key: 'deployments', label: 'Deployments' }],
  },
];

export const projectInfo = {
  name: 'movable objects',
  type: 'Object Detection',
  cover: '/static/demo4.png',
};
